
import Faq from "@/types/Faq";
import dayjs from "dayjs";
import {defineComponent, PropType} from "vue";
import Card from "../General/Card.vue";
import {mdiTrashCan} from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiEyeCheck  } from "@mdi/js";

import HcButton from "@/Components/Buttons/Button.vue";
import UserType from "@/types/User";
import {Link, usePage} from "@inertiajs/inertia-vue3";
import {Inertia} from "@inertiajs/inertia";

export default defineComponent({
  props: {
    faqs: {
      type: Object as PropType<Faq[]>,
      required: true,
    },

  },
  setup(props) {
    const getRelativeDate = (date: string) => {
      return dayjs(date).calendar();
    };
    const page = usePage<any>();
    const user: UserType = page.props.value.user;
    const getAbsoluteDate = (date: string) => {
      return dayjs(date).format("L LT");
    };




    //Test
    const deleteFaq = (faq: any) => {
      if (confirm(`Er du sikker på at du vil slette Faq'en "${faq.title}"`)) {
        Inertia.delete(
          route("faq.destroy", {
            faq: faq,
          }),
          {
            preserveScroll: true,
            preserveState: false,
          }
        );
      }
    };

    const navigateToFaq = (event: any, faq: any) => {
      Inertia.visit(route("faq.show", {faq: faq}));
    };

    return {
      getRelativeDate,
      getAbsoluteDate,
      mdiTrashCan: mdiTrashCan,
      deleteFaq,
      navigateToFaq,
      user,
      eyeIcon:mdiEyeCheck
    };
  },
  components: {Card, Link, SvgIcon, HcButton},
});
